<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection title="Daftar Pengajuan Koreksi">
          <!-- <div class="text-right">
            <ArgonButton :to="{ name: 'Create Assignment KPI Pegawai' }" isRouteLink>+ Tambah Assignment KPI</ArgonButton>
          </div> -->
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <!-- <CardComponent :useHeader="true"> -->
        <CardComponent use-header>
          <template v-slot:header-action>
            <GridRow class="w-100 mb-2">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="searchKeyword()" type="text" class="form-control"
                           placeholder="Cari nama atau nip disini..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.periode_id"
                      :list="list_periode"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Periode"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.unitkerja_id"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Unit Kerja"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.jabatan_id"
                      :list="list_jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Jabatan"
                    />
                  </FormGroup>

                  <!-- <FormGroup class="m-0 w-100">
                    <select  class="form-control" v-model="params.hasil" @change="getData()">
                      <option value="" selected>Pilih Hasil</option>
                      <option v-for="item in result_list" :key="item" :value="item">{{ item }}</option>
                    </select>
                  </FormGroup> -->

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.status"
                      :list="status_list.map((item) => {
                        return {
                          id: item,
                          value: status_label?.[item]
                        }
                      })"
                      option-value="id"
                      option-text="value"
                      placeholder="Pilih Status"
                    />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>                  
                  <th
                    v-for="item in thead"
                    :key="item"
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  >
                    {{ item }}
                  </th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data.length === 0">
                  <td :colspan="thead.length" class="text-center text-secondary">Data tidak ditemukan</td>
                </tr>
                <tr v-for="(item, index) in data" :key="index">
                  <td>{{ item?.nip || '-' }}</td>
                  <td class="font-weight-bolder">{{ item?.name || '-' }}</td>
                  <td>{{ item?.position || '-' }}</td>
                  <td><div class="column-truncate">{{ item?.unitkerja || '-' }}</div></td>
                  <td><div class="column-truncate">{{ item?.jabatan || '-' }}</div></td>
                  <!-- <td>
                    <span
                      v-if="item?.indeks_penilaian"
                      style="padding: .5rem .9rem"
                      class="rounded-circle text-white text-lg text-bold"
                      :class="result_color?.[item.indeks_penilaian] || 'bg-secondary'"
                    >
                      {{ item.indeks_penilaian }}
                    </span>
                    <span v-else>-</span>
                  </td> -->
                  <td>
                    <argon-badge
                      v-if="item?.status_koreksi && item?.status_koreksi !== '-'"
                      :color="status?.[item?.status_koreksi] || 'secondary'"
                      class="text-capitalize"
                    >
                      <!-- {{ item?.status_koreksi?.replaceAll('_', ' ') }} -->
                      {{ status_label?.[item?.status_koreksi] || item?.status_koreksi }}
                    </argon-badge>
                    <span v-else>-</span>
                  </td>

                  <td>
                    <ThreeDotsMenu>
                      <router-link
                        :to="{
                          name: 'Pengajuan Koreksi Detail',
                          params: {
                            employee_id: item.employee_id,
                            realization_id: item.realization_id,
                            status_koreksi: item.status_koreksi,
                            correction_id: item.correction_id,
                            periode_id: params.periode_id,
                          }
                        }"
                      >
                        Detail
                      </router-link>
                    </ThreeDotsMenu>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ArgonPagination
            :page="params.page"
            :total_page="metaData?.total_page"
            :current_page="metaData?.current_page"
            @changepage="getData"
            @changelimit="changeLimit"
          />
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import ArgonBadge from '@/components/ArgonBadge.vue';
// import ArgonButton from '@/components/ArgonButton.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import FormGroup from '@/components/FormGroup.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';


import KpiPeriodeApi from '@/repository/api/KpiPeriodeApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from '@/repository/api/JabatanApi';
import KoreksiApi from '@/repository/api/KoreksiApi';

import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "tables",
  components: {
    // ArgonButton,
    ArgonPagination,
    CardComponent,
    InputGroup,
    ArgonBadge,
    ThreeDotsMenu,
    FormGroup,
    MetaSection,
    GridRow,
    GridCol,
    ModelListSelect,
  },
  data() {
    return {
      timer: null,
      data: [],
      metaData: {},
      list_periode: [],
      unitkerja: [],
      list_jabatan: [],

      params: {
        page: 1,
        limit: 10,
        keyword: "",
        periode_id: "",
        unitkerja_id: "",
        jabatan_id: "",
        // hasil: "",
        status: "",
      },
      thead: [
        'NIP',
        'Nama',
        'Posisi',
        'Unit Kerja',
        'Jabatan',
        // 'Hasil Penilaian',
        'Status',
        '', // actions
      ],
      status_list: [
        'submission',
        // 'accept_direct_supervisor',
        // 'reject_direct_supervisor',
        'accept_immediate_supervisor',
        'reject_immediate_supervisor',
      ],
      status: {
        submission: 'primary',
        accept_direct_supervisor: 'info',
        reject_direct_supervisor: 'danger',
        accept_immediate_supervisor: 'success',
        reject_immediate_supervisor: 'danger',
      },
      status_label: {
        submission: 'Diajukan',
        resubmission: 'Diajukan Ulang',
        reject_direct_supervisor: 'Ditolak Direct SPV',
        accept_direct_supervisor: 'Diterima Direct SPV',
        revisi_direct_supervisor: 'Revisi Direct SPV',
        reject_immediate_supervisor: 'Ditolak Immediate SPV',
        accept_immediate_supervisor: 'Diterima Immediate SPV',
      },
      result_list: ['A', 'B', 'C', 'D', 'E', 'F'],
      result_color: {
        A: 'bg-success',
        B: 'bg-info',
        C: 'bg-warning',
        D: 'bg-warning',
        E: 'bg-danger',
        F: 'bg-danger',
      },
    };
  },
  watch: {
    'params.periode_id': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.status': function() {
      this.getData();
    },
    'params.unitkerja_id': function(newValue) {
      this.params.jabatan_id = '';
      
      if (newValue) {
        this.getJabatan();
      } else {
        this.list_jabatan = [];
      }
      this.getData();
    },
    'params.jabatan_id': {
      handler: async function () {
        await this.getData();
      }
    }
  },
  methods: {
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
          this.params.periode_id = response?.data?.[0]?.id || '';
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      // await UnitKerjaApi.get()
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
      })
        .then((response) => {
          this.unitkerja = response?.data;
        }).catch(() => {
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({
        unitkerja_id: this.params.unitkerja_id,
        page: 'all',
      })
        .then((response) => {
          this.list_jabatan = response?.data;
        }).catch(() => {
          this.list_jabatan = [];
        })
      this.$store.state.loading = false;
    },
    changeLimit(limit) {
      this.params.limit = limit;
      this.getData();
    },
    async searchKeyword() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        await this.getData();
      }, 650)
    },
    async getData(page=1) {
      this.$store.state.loading = true;
      this.data = [];
      this.metaData = {};
      this.params.page = page;

      await KoreksiApi.getListPengajuanKoreksi(this.params)
        .then((resp) => {
          // console.log(resp)
          this.data = resp?.data;

          this.metaData = {
            status: resp?.status ?? null,
            message: resp?.message ?? null,
            total_item: resp?.total_item ?? null,
            per_page: resp?.per_page ?? null,
            total_page: resp?.total_page ?? null,
            current_page: resp?.current_page ?? null,
          };
        })
        .catch((err) => {
          console.log(err)
        })
      this.$store.state.loading = false;
    },
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getKpiPeriode();
    await this.getUnitKerja();
    
    await this.getData();
    this.$store.state.loading = false;
  },
};
</script>
